import index from '@/views/Index.vue';
import traininglist from '@/views/TrainingList.vue';
import registrationinquire from '@/views/RegistrationInquire.vue';
import traininginquire from '@/views/TrainingInquire.vue';
import trainingdetail from '@/views/TrainingDetail.vue';
import trainingregistration from '@/views/TrainingRegistration.vue';
import sidemap from '@/views/Sidemap.vue';
import privacy from '@/views/Privacy.vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import Loading from 'vue-loading-overlay';
import VueSweetalert2 from 'vue-sweetalert2';
import infiniteScroll from 'vue-infinite-scroll';

// import router from './router';
import store from './store';

import '@/assets/css/reset.css';
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import '@/assets/css/layout.scss';
import '../static/css/animate.css';
import '@/assets/css/style.scss';

import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.component('Loading', Loading);
Vue.config.productionTip = false;
Vue.use(require('vue-moment'));

Vue.use(infiniteScroll);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);

// 全域啟用 ValidationProvider 跟 ValidationObserver(驗證規則元件)
// Vue.component('ValidationProvider', ValidationProvider);
// Vue.component('ValidationObserver', ValidationObserver);

// 把 Vee-validate 規則中文化

const components = [
  index,
  traininglist,
  registrationinquire,
  traininginquire,
  trainingdetail,
  trainingregistration,
  sidemap,
  privacy,
];
const install = (Vue, opts = {}) => {
  components.map((component) => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default { ...components, install };
